'use es6';

import PropTypes from 'prop-types';
import { Fragment, PureComponent } from 'react';
import ConnectedMessageEditor from '../../message-editor/containers/ConnectedMessageEditor';
import ConnectedThreadHistory from '../../thread-history/containers/ConnectedThreadHistory';
import ConnectedAlerts from '../containers/ConnectedAlerts';
import ConnectedProcessConsentPrompt from '../containers/ConnectedProcessConsentPrompt';
import CookieConsentPrompt from './CookieConsentPrompt';
import ConnectedWidgetBranding from '../containers/ConnectedWidgetBranding';
import ChatAreaAlert from 'conversations-visitor-experience-components/visitor-widget/ChatAreaAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ErrorBoundary from '../../components/ErrorBoundary';
import { END_OF_MESSAGE_DELAY_TIME } from '../../thread-history/constants/EndOfMessageDelayTime';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
class UnifiedThreadView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      renderNewThreadPrompt: !props.isThreadStarted || props.isThreadTransferred
    };
  }
  componentDidUpdate(prevProps) {
    const {
      isThreadStarted,
      toggleOnAndOffInputFocus,
      isThreadTransferred
    } = this.props;
    const {
      isThreadStarted: prevIsThreadStarted
    } = prevProps;
    if (!isThreadStarted && isThreadStarted !== prevIsThreadStarted || isThreadTransferred && isThreadTransferred !== prevProps.isThreadTransferred) {
      setTimeout(() => {
        this.setRenderNewThreadPromptTrue();
        toggleOnAndOffInputFocus(false);
      }, END_OF_MESSAGE_DELAY_TIME);
    }
    if (isThreadStarted && this.state.renderNewThreadPrompt && !isThreadTransferred) {
      this.setRenderNewThreadPromptFalse();
    }
  }
  setRenderNewThreadPromptTrue() {
    this.setState({
      renderNewThreadPrompt: true
    });
  }
  setRenderNewThreadPromptFalse() {
    this.setState({
      renderNewThreadPrompt: false
    });
  }
  renderMessageEditor() {
    const {
      requiresExplicitConsentToProcess,
      renderCookieConsentPrompt
    } = this.props;
    const {
      renderNewThreadPrompt
    } = this.state;
    if (requiresExplicitConsentToProcess || renderCookieConsentPrompt || renderNewThreadPrompt) {
      return null;
    }
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(ConnectedAlerts, {}), /*#__PURE__*/_jsx(ConnectedMessageEditor, {})]
    });
  }
  renderError() {
    const title = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-visitor-ui.network.pubSubFailure.title"
    });
    return /*#__PURE__*/_jsx(ChatAreaAlert, {
      title: title,
      onClose: () => {}
    });
  }
  render() {
    const {
      showingGdprProcess,
      showingHsBranding,
      renderCookieConsentPrompt,
      isThreadTransferred
    } = this.props;
    const {
      renderNewThreadPrompt
    } = this.state;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ErrorBoundary, {
        renderError: this.renderError,
        errorLoggingTitle: "ConnectedThreadHistory",
        children: /*#__PURE__*/_jsx(ConnectedThreadHistory, {
          shouldRenderNewThreadPrompt: renderNewThreadPrompt,
          isChatTransferred: isThreadTransferred
        })
      }), renderCookieConsentPrompt && /*#__PURE__*/_jsx(CookieConsentPrompt, {}), showingGdprProcess && !renderCookieConsentPrompt && /*#__PURE__*/_jsx(ConnectedProcessConsentPrompt, {}), this.renderMessageEditor(), showingHsBranding && /*#__PURE__*/_jsx(ConnectedWidgetBranding, {})]
    });
  }
}
UnifiedThreadView.displayName = 'UnifiedThreadView';
UnifiedThreadView.propTypes = {
  isThreadStarted: PropTypes.bool.isRequired,
  isThreadTransferred: PropTypes.bool,
  renderCookieConsentPrompt: PropTypes.bool.isRequired,
  requiresExplicitConsentToProcess: PropTypes.bool.isRequired,
  showingGdprProcess: PropTypes.bool.isRequired,
  showingHsBranding: PropTypes.bool.isRequired,
  toggleOnAndOffInputFocus: PropTypes.func.isRequired
};
export default UnifiedThreadView;